import { LeadsStatus } from '../../../../frontend/src/app/core/leads/leads';
import { ResourceName } from '../resource-name';

export const LeadsGate = {
  resource: ResourceName.leads,
  actions: {
    changeLeadsStatus: 'change-leads-status',
  },
};

export type LeadsGateActionTypes = {
  changeLeadsStatus: {
    request: ChangeLeadsStatusRequest;
    response: any;
  };
};

export interface ChangeLeadsStatusRequest {
  id: string;
  workspaceId: string;
  status: LeadsStatus;
}
